import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { useIdleTimer } from "react-idle-timer";

const useIdle = ({
  onIdle,
  idleTimeInMs,
  onAction = () => {},
  onActive = () => {},
}) => {
  const [isIdle, setIsIdle] = React.useState(null);
  const [isActive, setIsActive] = React.useState(null);

  const handleOnIdle = () => {
    setIsIdle(true);
    onIdle();
  };

  const handleOnAction = () => {
    onAction();
  };

  const handleOnActive = () => {
    setIsActive(true);
    onActive();
  };

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: idleTimeInMs ?? 1000,
    onAction: handleOnAction,
    onActive: handleOnActive,
    onIdle: handleOnIdle,
    debounce: 500,
  });

  return {
    getRemainingTime,
    getLastActiveTime,
    isIdle,
    isActive,
  };
};

export default useIdle;
